import { render } from "./area.vue?vue&type=template&id=e12e7680"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e12e7680"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e12e7680', __exports__)) {
    api.reload('e12e7680', __exports__)
  }
  
  module.hot.accept("./area.vue?vue&type=template&id=e12e7680", () => {
    api.rerender('e12e7680', render)
  })

}


export default __exports__